import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPixarAiGeneratorConfig } from '@/data/landingConfig/landingPixarAiGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PixarAiGenerator } from './schemaObject';

interface Props {}
const PixarAiGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PixarAiGenerator} />
			<LandingTemplate
				data={landingPixarAiGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default PixarAiGenerator;
